export const OFERTA_FILENAME = "Оферта_27.05.2026 - 1.pdf";
export const CURRENT_OFERTA_VERSION = OFERTA_FILENAME.replace("Оферта_", "").replace(".pdf", "");
export const OFERTA_PDF_PATH = `/docs/${OFERTA_FILENAME}`;

export const POLITICS_FILENAME = "Политика_ПД_27.05.2026 - 1.pdf";
export const CURRENT_POLITICS_VERSION = POLITICS_FILENAME.replace("Политика_ПД_", "").replace(".pdf", "");
export const POLITICS_PDF_PATH = `/docs/${POLITICS_FILENAME}`;
